var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"container"},[_c('div',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('div',{staticClass:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.intro)+" ")])]),_c('Button',{on:{"click":_vm.hideContainer}},[_vm._v("That's alright")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }